/* eslint-disable import/prefer-default-export */
import icon from '../assets/midlandsci.ico';

export const midlandConfig = {
  title: 'Midland',
  catalog: 'partner',
  partner: 'midland',
  origin: 'https://www.midlandsci.com/',
  host: 'https://catalog.midlandsci.com',
  logo: 'https://ecomseating.s3.amazonaws.com/images/other/msi-logo.png',
  logoURL: 'https://ecomseating.s3.amazonaws.com/images/other/msi-logo.png',
  buildAChair: 'midland',
  businessInfo: 'Midland Scientific, Inc., Omaha, NE 10651 Chandler Rd Suite 102 La Vista, NE',
  headerTheme: '#405694',
  secondaryTheme: '#3fb8a5',
  footerTheme: '#3d3d38',
  headerTextColor: '#FFFFFF',
  footerTextColor: '#FFFFFF',
  buttonTextColor: '#000000',
  extraAttributes: {
    trackId: '0000',
    icon,
  },
};